export var ILeanProductTile;
(function (ILeanProductTile) {
    let ILeanProduct;
    (function (ILeanProduct) {
        /**
         * Return an instance of ILeanProduct with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ILeanProduct.build = (partial) => (Object.assign({ board_tokens: [], promoted_by: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(ILeanProduct = ILeanProductTile.ILeanProduct || (ILeanProductTile.ILeanProduct = {}));
    let IBrand;
    (function (IBrand) {
        /**
         * Return an instance of IBrand with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IBrand.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IBrand = ILeanProductTile.IBrand || (ILeanProductTile.IBrand = {}));
    let IOptionsDetails;
    (function (IOptionsDetails) {
        let ISwatchDetails;
        (function (ISwatchDetails) {
            /**
             * Return an instance of ISwatchDetails with the provided fields. Any field not
             * listed will be populated with an empty value (an empty array,
             * or undefined, whichever is valid for the type of the value.)
             */
            ISwatchDetails.build = (partial) => (Object.assign({ swatch_preview_images: [] }, (partial !== null && partial !== void 0 ? partial : {})));
        })(ISwatchDetails = IOptionsDetails.ISwatchDetails || (IOptionsDetails.ISwatchDetails = {}));
        /**
         * Return an instance of IOptionsDetails with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IOptionsDetails.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IOptionsDetails = ILeanProductTile.IOptionsDetails || (ILeanProductTile.IOptionsDetails = {}));
    /**
     * Return an instance of ILeanProductTile with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    ILeanProductTile.build = (partial) => (Object.assign({ images: [], settings_to_assign_on_view: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(ILeanProductTile || (ILeanProductTile = {}));
